module.exports = __webpack_public_path__ + "static/media/about@2x.acc88314.jpg";